// app/src/features/boot/AccessNoticeStrip.jsx
import React from "react";
import { C } from "../../lib/colors.js";

/**
 * "No longer shared with you." A quiet strip rather than the modal the
 * watchlist-limit popup uses, and deliberately so: the limit popup reports a
 * DECISION the user must act on (remove one to add another), while this
 * reports something that already happened and needs nothing from them. It
 * auto-clears; the row it refers to is already gone from the list.
 *
 * Rendered beside `AppFrame` (not a frame slot), for the phone and the desktop layouts alike,
 * as the inline strip was; reads `accessNotice` (`useSharedAccessNotice`'s, AppInner's) from
 * the frame context.
 */
export default function AccessNoticeStrip({ ctx }) {
  const { accessNotice } = ctx;
  return (
    <>
      {accessNotice && (
        <div
          role="status"
          style={{
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: 28,
            zIndex: 660,
            maxWidth: "min(460px, 90vw)",
            background: C.panel,
            border: `1px solid ${C.purpleL}`,
            borderRadius: 10,
            padding: "11px 16px",
            fontSize: 12,
            lineHeight: 1.5,
            color: C.white,
            boxShadow: C.shadowBox,
            animation: "popupPanelIn 0.32s cubic-bezier(0.16,1,0.3,1) both",
          }}
        >
          {accessNotice}
        </div>
      )}
    </>
  );
}
